<template>
  <div class="card-infos">
    <component
      :is="getIconByMaterialType(materialType, true)"
      class="material-type-img"
    />

    <div class="info-offer">
      <div
        v-for="row in infoRows"
        :key="row.key"
        class="info-row"
      >
        <v-icon :class="['info-icon', materialColorClass]">
          {{ row.icon }}
        </v-icon>

        <div class="info-content">
          <span class="info-label">
            {{ row.label }}
          </span>
          <span class="offered-value">
            {{ row.value }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { MaterialType, MaterialTypeKey } from '@/enums/MaterialType';
import getIconsByMaterialType from '@/mixins/getIconsOfMaterialType';

export default {
  name: 'CardInfo',
  mixins: [getIconsByMaterialType],
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    hideOperator: {
      type: Boolean,
      default: false,
    },
    showYear: {
      type: Boolean,
      default: false,
    },
    business: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    materialType() {
      return this.mountMaterial(this.item.material_type);
    },

    materialColorClass() {
      return `material-${this.materialType}`;
    },

    yearNfes() {
      return Array.isArray(this.item?.year_nfes) ? this.item.year_nfes.join(', ') : '';
    },

    hasYearNfes() {
      return this.yearNfes.length > 0;
    },

    infoRows() {
      const rows = [];

      if (!this.hideOperator) {
        rows.push({
          key: 'operator_type',
          icon: 'mdi-domain',
          label: this.mountTranslate('operator_type'),
          value: this.mountTranslate(`business_kind.${this.item.business_kind}`),
        });

        rows.push({
          key: 'state',
          icon: 'mdi-map-marker-outline',
          label: this.mountTranslate('state'),
          value: this.item.business_state,
        });
      }

      rows.push(
        {
          key: 'available_for_purchase',
          icon: 'mdi-calendar-month-outline',
          label: this.mountTranslate('available_for_purchase'),
          value: this.item.created_at,
        },
        {
          key: 'material_type',
          icon: 'mdi-tag-outline',
          label: this.mountTranslate('material_type'),
          value: this.item.material_type,
        },
      );

      if (this.showYear && this.hasYearNfes) {
        rows.push({
          key: 'year_nfes',
          icon: 'mdi-file-document-outline',
          label: this.mountTranslate('year_nfes'),
          value: this.yearNfes,
        });
      }

      rows.push(
        {
          key: 'mass_quantity',
          icon: 'mdi-weight',
          label: this.mountTranslate('mass_quantity'),
          value: this.mountTranslate('mass_quantity_value', this.item.mass_quantity.toLocaleString('pt-BR')),
        },
        {
          key: 'total_offer',
          icon: 'mdi-cash-multiple',
          label: this.mountTranslate('total_offer'),
          value: this.mountTranslate('total_offer_value', this.item.credits_quantity.toLocaleString('pt-BR')),
        },
      );

      return rows;
    },

    isRecEntity() {
      return this.business && this.business?.entity_flag;
    },
  },

  methods: {
    mountTranslate(path, value) {
      return this.$t(`components.offered.card_offered.${path}`, {
        value,
      });
    },

    mountMaterial(material) {
      switch (material) {
        case MaterialType.PAPER:
          return MaterialTypeKey.PAPER;
        case MaterialType.PLASTIC:
          return MaterialTypeKey.PLASTIC;
        case MaterialType.GLASS:
          return MaterialTypeKey.GLASS;
        default:
          return MaterialTypeKey.METAL;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.card-infos {
  display: flex;
  align-items: center;
  flex: 1;
  width: 100%;
  gap: 20px;
  min-width: 0;

  .material-type-img {
    width: 140px;
    min-width: 140px;
    flex-shrink: 0;
  }

  .info-offer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    min-width: 0;

    .info-row {
      display: flex;
      align-items: center;
      gap: 14px;
      padding: 14px 0;
      border-bottom: 1px solid $border_color_divider;

      &:last-child {
        border-bottom: 0;
      }
    }

    .info-icon {
      font-size: 22px;
    }

    .material-paper {
      color: $color_paper;
    }

    .material-plastic {
      color: $color_plastic;
    }

    .material-glass {
      color: $color_glass;
    }

    .material-metal {
      color: $color_metal;
    }

    .info-content {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 6px;
      min-width: 0;
      line-height: 1.45;
    }

    .info-label {
      font-weight: 700;
      color: $color_dark;
      line-height: 1.45;
    }

    .offered-value {
      font-size: 1em;
      color: $color_gray;
      line-height: 1.45;
    }
  }
}
</style>
